/**
 * Copyright 2024-2026 Wingify Software Pvt. Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { LogLevelEnum } from './packages/logger/enums/LogLevelEnum';
import { Connector, ISettingsData } from './packages/storage/Connector';

import { IWingifyOptions } from './models/WingifyOptionsModel';
import { IWingifyClient } from './WingifyClient';
import { IWingifyContextModel } from './models/user/ContextModel';
import { Flag } from './api/GetFlag';
import { getUUID } from './utils/UuidUtil';
import { NetworkTransportModeEnum } from './enums/NetworkTransportModeEnum';

export { init, onInit } from './Wingify';
export { LogLevelEnum, Connector as StorageConnector, ISettingsData };
export { IWingifyOptions, IWingifyClient, IWingifyContextModel, Flag, getUUID };
export { ClientStorageOptions } from './packages/storage/connectors/BrowserStorageConnector';
export { IRetryConfig } from './packages/network-layer/client/NetworkClient';
export { NetworkTransportModeEnum };
